import uuid from 'uuid'
import BlockTypes from '@slite/editor/lib/types/BlockTypes'
import { SUGGESTION_FOR } from '../../integration-suggestion/components'
import insertNodeAfterBlockWithId from '../utils/insertNodeAfterBlockWithId'

export default function makeIntegrationTileExtractor({
  getApplications,
  onIntegrationTileCreated,
  getNewIntegrationTileAttributes,
  isEnableAppSuppressed,
  isConnectAppSuppressed,
}) {
  return function integrationTileExtractor(
    editor,
    { url, ref, bypassSuggestion = false }
  ) {
    const applications = getApplications()

    if (!applications) {
      return false
    }

    const matchingApplication = applications.find(({ integration }) => {
      if (!integration) {
        return false
      }

      const found = integration.unfurlPatterns.find(pattern => {
        const regexp = new RegExp(pattern)

        return regexp.test(url || '')
      })

      return Boolean(found)
    })

    if (!matchingApplication) {
      return false
    }

    if (!bypassSuggestion && !matchingApplication.isInstalled) {
      if (isEnableAppSuppressed(matchingApplication.clientId)) {
        return false
      }

      return {
        node: {
          object: 'block',
          type: BlockTypes.INTEGRATION_SUGGESTION,
          data: {
            id: uuid(),
            clientId: matchingApplication.clientId,
            name: matchingApplication.name,
            for: SUGGESTION_FOR.enableApp,
          },
        },
      }
    }

    const attributes = getNewIntegrationTileAttributes(matchingApplication)

    const node = {
      object: 'block',
      type: BlockTypes.INTEGRATION_TILE,
      data: {
        ...attributes,
        id: uuid(),
        v: 0,
        atomic: true, // useful for legacy editor
        depth: 0,
        transient: true,
        collapsed: true,
        title: 'Pending tile...',
        status: {
          label: 'Pending',
          colorHex: '#F6F6F6',
        },
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    }
    const callback = () => {
      onIntegrationTileCreated({ ...attributes, url })
    }
    insertNodeAfterBlockWithId(editor, ref, node)
    editor.command('addOnSyncDoneCallback', callback)
    return node
  }
}
